import { JobInterview } from "src/types";
import Conversation from "../components/Conversation";
import { ReactComponent as NoComment } from "src/assets/svg/no-communication.svg";
import Job from "src/types/models/Job";
import VideosSection from "../components/VideosSection";

const Recording = ({ interview, job }: { interview: JobInterview; job?: Job }) => {
  const { Videos, Transcripts } = interview;

  const uploaded = Videos?.filter((kvs) => !!kvs.duration_range);
  if (!Transcripts?.length && !uploaded?.length)
    return (
      <div className="mx-auto flex flex-col items-center gap-6 pt-[120px]">
        <NoComment className="w-[220px] h-[220px]" />
        <p className="font-poppins text-xl font-semibold">No Records Found</p>
      </div>
    );

  return (
    <div className="mt-9">
      <VideosSection videos={uploaded} interview={interview} />
      <Conversation interview={interview} job={job} />
    </div>
  );
};

export default Recording;
